{
  "nl": {
    "dashboard": {
      "greetings": {
        "afternoon": "Goedemiddag {first_name}",
        "evening": "Goedenavond {first_name}",
        "morning": "Goedemorgen {first_name}",
        "night": "Goedenacht {first_name}"
      },
      "titles": {
        "activityFeed": "Activiteiten",
        "assignedTasks": "Mijn Taken",
        "newsFeed": "Nieuwsoverzicht",
        "ongoingTickets": "In Behandeling",
        "openTickets": "Open",
        "tickets": "Gesprekken",
        "totalTickets": "Alle",
        "unreadTickets": "Ongelezen",
        "yourAssignedTickets": "Jouw toegewezen gesprekken"
      }
    }
  }
}